import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueSimpleAlert from "vue-simple-alert";
import { MsalPlugin, MsalPluginOptions } from './plugins/msal-plugin';
import './style.scss';

import axios from '@/plugins/axios';

Vue.use(axios);

Vue.use(VueSimpleAlert);

Vue.config.productionTip = false;

const options: MsalPluginOptions = {
  clientId: process.env.VUE_APP_MSAL_CLIENT_ID,
  loginAuthority:  process.env.VUE_APP_MSAL_LOGIN_AUTHORITY,
  passwordAuthority: process.env.VUE_APP_MSAL_PASSWORD_RESET_AUTHORITY,
  knownAuthority: process.env.VUE_APP_MSAL_KNOWN_AUTHORITY
};

Vue.use(new MsalPlugin(), options);

router.beforeEach((to, from, next) => {
  const title = to.meta.title != null ? ' - ' + to.meta.title : '';
  document.title = 'Compliance Help' + title;
  const favicon = "https://stlgpdhub.blob.core.windows.net/assets/ComplianceHelp%20icon%2032x32.png";
  //@ts-ignore
  document.querySelector('head').innerHTML += `<link href="${favicon}" rel="icon" type="image/png" />`;
  next();
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount('#app');